module.exports = __webpack_public_path__ + "img/insta-ic.dd32116b.svg";